export default {"src":"/_next/static/media/Group 427321833.bb5c5d73.svg","height":155,"width":459,"blurWidth":0,"blurHeight":0};